import Skeleton from "react-loading-skeleton";
import { arrayMap } from "../../../../utils/array.utils";
import { getRandomNumber } from "../../../../utils/number.utils";
import SubCardTitle from "../../../../components/styled/SubCardTitle";

export default function VehicleShowroomWorksViewCard({ title, data }) {
  return (
    <div className="card border-0" style={{ height: `100%` }}>
      <div className="card-body">
        <SubCardTitle>{title ?? ""}</SubCardTitle>
        <ul className="list-unstyled mb-0">
          {arrayMap(data, (item, index) => (
            <li key={index}>
              <span style={{ fontWeight: 500 }}>{item.label}: </span>
              {item.value}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

// InventoryViewCard skeleton
export function InventoryViewCardSkeleton() {
  return (
    <div>
      <p className="mb-0">
        <Skeleton width={`40%`} />
      </p>
      <ul className="list-unstyled mb-0">
        {arrayMap(Array(5).fill(0), (item, index) => (
          <li key={index}>
            <Skeleton width={`${getRandomNumber()}%`} />
          </li>
        ))}
      </ul>
    </div>
  );
}
